import type { Subcategory } from '../../categories'
import { NATERA_TAGS } from '../config'
import CARCS_JSON from '../config/json/CARCS.json'
import OTHER_JSON from '../config/json/Other.json'
import RARCS_JSON from '../config/json/RARCS.json'
import { byCode, type CodeOption } from './code-utils'

const ALL_CODES = [...OTHER_JSON, ...CARCS_JSON, ...RARCS_JSON]

export function getNateraTagOptions(
  categoryMetadata: Subcategory['metadata'] | null,
  serverValues: string[] | undefined,
): CodeOption[] {
  if (!categoryMetadata) {
    return []
  }
  const options = NATERA_TAGS.filter(
    (c) =>
      ((c.phase.length === 0 || c.phase.includes(categoryMetadata.phase.label)) &&
        (c.outcome.length === 0 || c.outcome.includes(categoryMetadata.outcome.label)) &&
        (c.reason.length === 0 || c.reason.includes(categoryMetadata.reason.label))) ||
      serverValues?.includes(c.code), // If the value is already in the server values, we need to show it in the dropdown
  )
    .map((c) => ({
      label: `${c.code} - ${c.label}`,
      value: c.code,
      description: c.description,
      occurrences: c.occurrences,
    }))
    .sort(byCode)
  if (!serverValues || serverValues.length === 0) {
    return options
  }
  const additionalOptions = serverValues
    .filter((value) => !options.some((c) => c.value === value))
    .map((value) => {
      const tag = NATERA_TAGS.find((t) => t.code === value)
      const allTag = !tag ? ALL_CODES.find((t) => t.code === value) : null
      return {
        label: tag
          ? `${tag.code} - ${tag.label}`
          : allTag
            ? `${allTag.code} - ${allTag.label}`
            : value,
        value: value,
        description: tag?.description ?? allTag?.description ?? '',
        occurrences: tag?.occurrences ?? allTag?.occurrences ?? 0,
        hidden_from_search: !tag,
      }
    })
  return [...options, ...additionalOptions].sort(byCode)
}
